import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import InnerHTML from '@Components/InnerHTML';

function PatentTitle({ title, tag, className }) {
  return title ? (
    <InnerHTML tag={tag} html={title} className={cn('patent-content__title u-els-font-family-serif', className)} />
  ) : (
    <span className={cn('patent-content__title u-els-font-family-serif', className)}>No title</span>
  );
}

PatentTitle.propTypes = {
  title: PropTypes.string,
  tag: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default PatentTitle;
